import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

export default function AlertDialogSlide(props) {
    const { t } = useTranslation("translation");
    return (
        <div>
            <Dialog id="cp_Dialog" open={props.open} keepMounted onClose={props.onClose}>
                <DialogTitle id="cp_DialogTitle">{t("UpdateTask")}</DialogTitle>
                <DialogContent id="cp_DialogContent">
                    <DialogContentText id="cp_DialogContentText">{t("ChangeMaintenanceTaskDate")}</DialogContentText>
                    <DialogContentText id="cp_DialogContentText_1">
                        {t("OldDate")}: {props.oldDate}
                    </DialogContentText>
                    <DialogContentText id="cp_DialogContentText_2">
                        {t("NewDate")}: {props.newDate}
                    </DialogContentText>
                </DialogContent>
                <DialogActions id="cp_DialogActions">
                    <Button id="cp_b" onClick={props.onClose} color="secondary" variant="contained">
                        {t("Cancel")}
                    </Button>
                    <Button id="cp_b_1" onClick={props.updateOnce} color="primary" variant="contained">
                        {t("Confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
